module.exports = __webpack_public_path__ + "static/madebya-web-logo-320x320.2523665e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/madebya-web-logo-320x320.png
// module id = 74
// module chunks = 35783957827783 162898551421021 253626871324061